import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '../window';

@Injectable({
  providedIn: 'root'
})
export class AutostartPageService {
  constructor(@Inject(WINDOW) private window: Window) {}

  markPageAsAutostartPage(): void {
    this.window.history.replaceState({ autostartPage: true }, '');
  }

  isAutostartPage(): boolean {
    return this.window.history.state?.autostartPage === true;
  }
}
